module.exports = __webpack_public_path__ + "assets/pro-licences-disable.0482732f.svg";